import clsx from 'clsx'
import React, { forwardRef, RefObject } from 'react'

import AngleRight from '@Assets/SVG/AngleRight'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { Button } from '@CoreComponents/Buttons/Button'
import { useTranslation } from '@Globals/Translations'

import styles from './DroppointItem.module.scss'

export const DroppointInfoTemplateV2 = forwardRef<HTMLDivElement>((props, ref: RefObject<HTMLDivElement>) => {
  const { t } = useTranslation()

  return (
    <div className={styles.infoBoxTemplate} ref={ref}>
      <div className={clsx(styles.droppointItem, styles.droppointItemOverlay)}>
        <div className={styles.distance}>
          {'{{distance}}'}
          {t('checkout:KILOMETER_SHORT')}
        </div>
        <strong>{'{{name}}'}</strong>
        <div>{'{{streetName}}'}</div>
        <div>{'{{postalCode}} {{city}}'}</div>
        <div className={clsx(styles.openHoursTrigger, 'js-opening-trigger')}>
          {t('checkout:COF_OPENING_HOURS')}
          <SVGIcon icon={AngleRight} size="12px" />
        </div>
        <div className={clsx(styles.openingList, 'hidden', 'js-opening-list')} />
        <Button className={clsx('js-select-button', styles.apply)} innerSpacing="medium" theme="black">
          {t('checkout:COF_SELECT')}
        </Button>
      </div>
    </div>
  )
})
